import { Injectable } from '@angular/core';
import {
    ActivatedRouteSnapshot,
    CanActivate,
} from '@angular/router';
import { Router } from '@angular/router/';

@Injectable()
export class PasswordChangeGuard implements CanActivate {
    constructor(
        private _router: Router,
    ) { }

    canActivate(
        route: ActivatedRouteSnapshot,
    ) {
        this._removeSensitiveURLData(route);
        return true;
    }

    private _removeSensitiveURLData(route: ActivatedRouteSnapshot) {
        const { code, ...queryParams } = route.queryParams;
        if (code) {
            this._router.navigate([
                '/account/passwordchange',
            ], {
                state: {
                    code,
                },
                queryParams,
                replaceUrl: true,
            });
        }
    }
}
